import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Export dropdown. Owns its own open/close + click-outside handling so the
// list pages no longer each repeat that effect.
const ExportMenu = ({ onExport }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const pick = (format) => {
    setOpen(false);
    onExport(format);
  };

  return (
    <div className="ad-menu-wrap" ref={wrapRef}>
      <button
        type="button"
        className="ad-icon-btn"
        title={t('common.export')}
        onClick={() => setOpen(!open)}
      >
        <i className="fas fa-file-export"></i>
      </button>

      {open && (
        <div className="ad-menu">
          <button type="button" onClick={() => pick('excel')}>
            <i className="fas fa-file-excel"></i> {t('common.exportExcel')}
          </button>
          <button type="button" onClick={() => pick('csv')}>
            <i className="fas fa-file-csv"></i> {t('common.exportCsv')}
          </button>
          <button type="button" onClick={() => pick('pdf')}>
            <i className="fas fa-file-pdf"></i> {t('common.exportPdf')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportMenu;
